import Player from "@vimeo/player";

export default () => {
	const vimeoWrap = document.querySelectorAll(".link-vimeo");

	if (!vimeoWrap) return;

	vimeoWrap.forEach(item => {
		let iframeVimeo = item.querySelector(" iframe"),
			playButton = item.querySelector(".video-play-btn"),
			videoImage = item.querySelector(".poster-img"),
			player = new Player(iframeVimeo);

		item.addEventListener("click", () => {
			item.classList.add('play');

			player.play();
			setTimeout(()=> {
				playButton.remove();
				videoImage.remove();
			}, 300);
		});
	});
};



// WEBPACK FOOTER //
// ./scripts/modules/video-play.js